<template>
    <v-form ref="registration">
        <v-stepper v-model="step" flat>
          <v-stepper-header class="elevation-0">
            <v-stepper-step :complete="step > 1" step="1">Persönliche Daten</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Kategorie</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">Datenschutz</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 4" step="4">Zusammenfassung</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1" class="pa-0 px-md-6">
            <v-card>
              <v-card-subtitle v-if="!step1Validation">
                <v-alert :value="!step1Validation" type="error">Bitte korrigieren Sie die rot markierten Felder!</v-alert>
              </v-card-subtitle>
                <v-form v-model="step1Validation" lazy-validation ref="step1">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-radio-group
                                                :rules="[rules.required]"
                                                label="Anrede*"
                                                name="gender"
                                                row
                                                v-model="registration.gender">
                                            <v-radio color="secondary" label="Herr" value="male"></v-radio>
                                            <v-radio color="secondary" label="Frau" value="female"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field :rules="[rules.required]" label="Vorname*" name="firstname"
                                                      v-model="registration.firstname"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field :rules="[rules.required]" label="Nachname*" name="lastname"
                                                      v-model="registration.lastname"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                      <v-text-field v-maska data-maska="##.##.####" v-model="registration.dateOfBirth" :rules="[rules.required, rules.date]" label="Geburtsdatum"></v-text-field>
                                      <!--
                                        <v-menu
                                                :close-on-content-click="false"
                                                min-width="290px"
                                                offset-y
                                                ref="dateOfBirthPicker"
                                                transition="scale-transition"
                                                v-model="dateOfBirthPicker"
                                        >
                                            <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    :rules="[rules.required]"
                                                    :value="displayGermanDate(registration.dateOfBirth)"
                                                    label="Geburtsdatum*"
                                                    name="dateOfBirth"
                                                    prepend-icon="fa-calendar-day"
                                                    readonly
                                                    v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    :first-day-of-week="1"
                                                    :max="new Date().toISOString().substr(0, 10)"
                                                    @change="saveDateOfBirth"
                                                    locale="de-de"
                                                    ref="picker"
                                                    v-model="registration.dateOfBirth"
                                                    :active-picker.sync="activePicker"
                                            ></v-date-picker>
                                        </v-menu>-->
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="3">
                                        <v-text-field :rules="[rules.required]" label="Straße + Hausnummer*" name="street" v-model="registration.street"></v-text-field>
                                    </v-col>
                                    <v-col cols="4" md="2">
                                        <v-text-field :rules="[rules.required, rules.postal, rules.numberOnly]" label="Postleitzahl*" name="postal" v-model="registration.postal"></v-text-field>
                                    </v-col>
                                    <v-col cols="8" md="4">
                                        <v-text-field :rules="[rules.required]" label="Ort*" name="city" v-model="registration.city"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field :rules="[rules.required]" label="Land*" name="country" v-model="registration.country"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                                :rules="[rules.required]"
                                                label="Telefon*"
                                                name="phone"
                                                prepend-icon="fal fa-phone"
                                                v-model="registration.phone"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                                :rules="[rules.required, rules.email]"
                                                label="E-Mail*"
                                                name="email"
                                                prepend-icon="fal fa-envelope"
                                                v-model="registration.email"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                </v-form>
              <v-card-actions><v-btn color="primary" @click="nextStep()">Weiter</v-btn></v-card-actions>
            </v-card>
          </v-stepper-content>
            <v-stepper-content step="2" class="pa-0 px-md-6">
                <v-card>
                    <v-card-text>
                        <v-form v-model="step2Validation" lazy-validation ref="step2">
                            <v-row v-if="!step2Validation">
                                <v-col>
                                    <v-alert :value="!step2Validation" type="error">Bitte wählen Sie eine Kategorie!</v-alert>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-radio-group :rules="[rules.required]" label="Kategorie*" v-model="registration.category">
                                        <v-row>
                                            <v-col v-for="category in categories" :key="category.id" cols="12" md="6" lg="4">
                                                <v-radio :label="category.title" :value="category.id"></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="justify-center headline">
                                    Preis für die gewählte Kategorie: {{ calcPrice(registration.category) }} €
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                <v-btn @click="prevStep()">Zurück</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="nextStep()">Weiter</v-btn>
                    </v-card-actions>
                </v-card>
            </v-stepper-content>
            <v-stepper-content step="3"  class="pa-0 px-md-6">
                <v-card>
                    <v-card-text>
                        <v-form v-model="step3Validation" lazy-validation ref="step3">
                            <p>
                                Zur Teilnehme am Wettbewerb lesen Sie bitte die <a :href="event.announcement" target="_blank">Ausschreibung des Ausrichter</a> und akzeptieren diese.<br>
                                <v-checkbox label="Ich akzeptiere die Ausschreibung des Ausrichters" :rules="[rules.required]" v-model="announcement"></v-checkbox>
                            </p>
                            <p>
                                Ja, ich habe die <a href="https://www.drussen.de/datenschutz.html" target="_blank">Datenschutzerklärung</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden.
                                Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage benutzt.  Mit dem Absenden des Formulars erkläre ich mich mit der Verarbeitung einverstanden. <br>
                                <v-checkbox label="Hiermit bestätige ich die Datenschutzerklärung gelesen zu haben" :rules="[rules.required]" v-model="dataPrivacy"></v-checkbox>
                            </p>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="prevStep()">Zurück</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="nextStep()">Weiter</v-btn>
                    </v-card-actions>
                </v-card>
            </v-stepper-content>
            <v-stepper-content step="4"  class="pa-0 px-md-6">
                <v-card>
                    <v-card-text>
                        <v-simple-table>
                            <tbody>
                            <tr>
                                <td>Geschlecht</td>
                                <td>{{ registration.gender === 'male' ? 'Herr' : 'Frau' }}</td>
                            </tr>
                            <tr>
                                <td>Vorname</td>
                                <td>{{ registration.firstname }}</td>
                            </tr>
                            <tr>
                                <td>Nachname</td>
                                <td>{{ registration.lastname }}</td>
                            </tr>
                            <tr>
                                <td>Geburtstag</td>
                                <td>{{ registration.dateOfBirth }}</td>
                            </tr>
                            <tr>
                                <td>Straße</td>
                                <td>{{ registration.street }}</td>
                            </tr>
                            <tr>
                                <td>Ort</td>
                                <td>{{ registration.postal }} {{ registration.city }}</td>
                            </tr>
                            <tr>
                                <td>Land</td>
                                <td>{{ registration.country }}</td>
                            </tr>
                            <tr>
                                <td>Telefon</td>
                                <td>{{ registration.phone }}</td>
                            </tr>
                            <tr>
                                <td>E-Mail</td>
                                <td>{{ registration.email }}</td>
                            </tr>
                            <tr>
                                <td>Kategorie</td>
                                <td>{{ categoryTitle }}</td>
                            </tr>
                            <tr>
                                <td>Gesamtbeitrag</td>
                                <td>{{ amount }} €</td>
                            </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="prevStep()">Zurück</v-btn>
                        <v-spacer></v-spacer>

                        <v-btn @click="register" color="primary" data-cy="register">
                            Verbindlich anmelden
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-stepper-content>
            <v-stepper-content step="5" class="pa-0 px-md-6">
              <v-card min-height="400">
                <v-card-title class="text-no-wrap">Vielen Dank für deine Registrierung</v-card-title>
                <v-card-text>
                  <v-alert type="success" prominent outlined>
                    Deine Registrierung war erfolgreich. Du erhälst in Kürze eine E-Mail mit weiteren Details.
                  </v-alert>
                  <div v-if="(paypal.production !== null || paypal.sandbox !== null) && paypalResponse === null && amount > 0">
                    <p class="py-4">Die Anmeldung ist nur mit Einzahlung des Startgeldes gemäß Ausschreibungstext gültig.
                      Es besteht die Möglichkeit das Startgeld direkt per PayPal zu bezahlen oder zu überweisen.
                      Die Zahlung per PayPal ist nur pro Teilnehmer möglich.
                      Sie können im Anschluss weitere Teilnehmer hinzufügen.
                      Details zur Überweisung entnehmen Sie bitte der Ausschreibung.</p>
                    <PayPal v-if="paypalResponse === null" class="mt-4" :button-style="{'shape': 'rect', 'size': 'large'}" :client="paypal" :amount="amount.toString()" currency="EUR" :items="paypalItem" v-on:payment-error="paymentError" v-on:payment-cancelled="paymentCancelled" v-on:payment-completed="paymentCompleted"></PayPal>
                    <v-alert type="success" colored-border border="bottom" v-else>Ihre Zahlung war erfolgreich.</v-alert>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="addNewParticipant" color="primary">
                    Weitere Person anmelden
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <v-snackbar :multi-line="true" :top="true" color="error" v-model="paymentStatusErrorSnackbar" timeout="-1">
            Dein Zahlvorgang konnte leider nicht abgeschlossen werden. Bitte probiere es erneut oder wähle eine andere
            Zahlweise.
            <v-btn @click="paymentStatusErrorSnackbar = false" color="white" text>Schließen</v-btn>
        </v-snackbar>
        <v-snackbar :multi-line="true" :top="true" color="success" v-model="paymentStatusSuccessSnackbar" timeout="-1">
          Der Zahlvorgang wurde erfolgreich abgeschlossen. Viel Spaß bei der Veranstaltung.
          <v-btn @click="paymentStatusSuccessSnackbar = false" color="white" text>Schließen</v-btn>
        </v-snackbar>
        <v-snackbar :multi-line="true" :top="true" color="success" v-model="registrationStatus" timeout="-1">
            Deine Registrtierung war erfolgreich. Du erhälst in Kürze eine E-Mail mit weiteren Details.
            <v-btn @click="registrationStatus = false" color="white" text>Schließen
            </v-btn>
        </v-snackbar>
        <v-snackbar :multi-line="true" :top="true" color="error" v-model="formStatus">
            Bitte korrigieren Sie die rot markierten Felder.
            <v-btn @click="formStatus = false" color="white" text>Schließen</v-btn>
        </v-snackbar>
    </v-form>
</template>import './plugins/mask'

<script>
    import PayPal from 'vue-paypal-checkout'
    import axios from 'axios'
    import { vMaska } from "maska"

    export default {
        name: 'RegistrationForm',
      directives: { maska: vMaska },
        components: {
            PayPal
        },
        props: {
            event: {
                type: Object,
                default: function () {
                    return {
                        'title': 'Drussen Testevent'
                    }
                }
            },
            categories: {
                type: Array
            }
        },
        computed: {
            amount() {
                let value = 0;
                if (this.registration.category !== null) {
                    value += this.calcPrice(this.registration.category)
                }
                return value
            },
            categoryTitle () {
                let element = this.categories.find(item => item.id === this.registration.category)
                if (element === undefined) {
                    return 'Keine Kategorie gewählt'
                }
                return element.title
            },
          paypalItem () {
              return  [{
                "name": this.event.title,
                "description": this.categoryTitle + ' - ' + this.registration.firstname + ' ' + this.registration.lastname,
                "quantity": "1",
                "price": this.amount,
                "currency": "EUR"
              }]
          }
        },
        data: () => ({
          participantId: null,
          participantToken: null,
          activePicker: null,
          paypalResponse: null,
          paypal: {
            production: null,
            sandbox: null
          },
          announcement: false,
          dataPrivacy: false,
          step: 1,
          steps: 5,
          step1Validation: false,
          step2Validation: false,
          step3Validation: false,
          formStatus: false,
          registrationStatus: false,
          paymentStatusErrorSnackbar: false,
          paymentStatusSuccessSnackbar: false,
          dateOfBirthPicker: false,
          defaultRegistration: {
            gender: null,
            firstname: '',
            lastname: '',
            street: '',
            postal: '',
            city: '',
            country: '',
            phone: '',
            email: '',
            dateOfBirth: '',
            paymentMethod: 'bank',
            category: null,
            canceled: false
          },
          registration: {
            gender: null,
            firstname: '',
            lastname: '',
            street: '',
            postal: '',
            city: '',
            country: '',
            phone: '',
            email: '',
            dateOfBirth: '',
            paymentMethod: 'bank',
            category: null,
            canceled: false
          },
          rules: {
            required: value => !!value || 'Pflichtfeld',
            requiredRadio: value => value !== null || 'Bitte treffen Sie eine Auswahl',
            postal: value => {
              if (value !== undefined && value.length === 5) return true
              return  'Bitte geben Sie eine gültige Postleitzahl an'
            },
            streetNumber: value => {
              const pattern = /^[0-9]+[ a-zA-Z]{0,2}$/;
              return pattern.test(value) || 'Keine korrekte Hausnummer'
            },
            date: value => {
              const pattern = /^[0-3]{0,1}[0-9]{1}\.[0-1]{0,1}[0-9]{1}\.[0-9]{4}$/;
              return pattern.test(value) || 'Kein korrektea Datum (tt.mm.jjjj)'
            },
            numberOnly: value => {
              const pattern = /^[0-9]+$/;
              if (value === undefined || value === '') {
                return true
              } else if (pattern.test(value) && value > 0) {
                return true
              }
              return 'Bitte geben Sie nur Zahlen ein.'
            },
            email: value => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || 'Bitte geben Sie eine gültige E-Mailadresse ein.'
            }
          }
        }),
        methods: {
            register: function () {
                if (this.step1Validation && this.step2Validation && this.step3Validation) {
                    axios.post('/register', {
                        'eventToken': this.event.token,
                        'categoryId': this.registration.category,
                        'gender': this.registration.gender,
                        'firstname': this.registration.firstname,
                        'lastname': this.registration.lastname,
                        'email': this.registration.email,
                        'phone': this.registration.phone,
                        'street': this.registration.street,
                        'postal': this.registration.postal,
                        'city': this.registration.city,
                        'country': this.registration.country,
                        'dateOfBirth': this.registration.dateOfBirth.split('.').reverse().join('-'),
                        'canceled': false
                    }).then((response) => {
                        this.registrationStatus = true;
                        this.participantId = response.data.id
                        this.participantToken = response.data.token
                        this.step = 5
                    })
                } else {
                    this.$refs.registration.validate();
                    this.formStatus = true
                }
            },
            paymentCompleted: function (response) {
              this.paymentStatusSuccessSnackbar = true
              this.paypalResponse = response
              this.updatePaymentStatus(response)
            },
            paymentCancelled: function () {
              this.paymentStatusSnackbar = true
              this.paypalResponse = null
            },
            paymentError: function () {
              this.paymentStatusErrorSnackbar = true
              this.paypalResponse = null
            },
            saveDateOfBirth() {
                this.$refs.dateOfBirthPicker.save(this.registration.dateOfBirth)
            },
            calcPrice(categoryId) {
                const category = this.categories.find(category => category.id == categoryId)
                if (category === undefined) {
                    return '--,--'
                }
                return category.price
            },
            displayGermanDate (date) {
                if (date !== undefined && date !== '') {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`
                }
                return ''
            },
            nextStep () {
                if (this.$refs['step' + this.step].validate()) {
                    if (this.step === this.steps) {
                        this.step = 1
                    } else {
                        this.step = this.step + 1
                    }
                }
            },
            prevStep () {
                    if (this.step === 1) {
                        this.step = 1
                    } else {
                        this.step = this.step - 1
                    }
            },
            addNewParticipant () {
              this.registration = Object.assign({}, this.defaultRegistration);
              this.announcement = false;
              this.dataPrivacy = false;
              this.paypalResponse = null;
              this.$refs.registration.reset();
              this.step = 1;
            },
            updatePaymentStatus(response) {
              axios.post('/register/payment', {
                id: this.participantId,
                token: this.participantToken,
                response: response
              })
            }
        },
        watch: {
            dateOfBirthPicker(val) {
                val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
            }
        },
      mounted() {
          this.paypal.production = this.event.paypalApiKey
      }
    }
</script>
